import { render, staticRenderFns } from "./NotificationOpenDoc.vue?vue&type=template&id=738eec08"
import script from "./NotificationOpenDoc.vue?vue&type=script&lang=js"
export * from "./NotificationOpenDoc.vue?vue&type=script&lang=js"
import style0 from "./NotificationOpenDoc.vue?vue&type=style&index=0&id=738eec08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports